import { render, staticRenderFns } from "./PropertyStatusForm.vue?vue&type=template&id=5120c10e&"
import script from "./PropertyStatusForm.vue?vue&type=script&lang=js&"
export * from "./PropertyStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports